export default [
   {
      "value": "Employee",
      "label": "Employee"
   },
   {
      "value": "Supervisor",
      "label": "Supervisor"
   },
   {
      "value": "Manager",
      "label": "Manager"
   },
   {
      "value": "CEO",
      "label": "CEO"
   },
   {
      "value": "salesman",
      "label": "salesman"
   },
   {
      "value": "tester", // TODO: remove me later
      "label": "tester"
   },
]